import { CargoAction } from "__generated__/graphql";
import moment from "moment";
import { FormattedDate, FormattedDateWindow } from "utils/DateUtils";

type CargoActionDateProps = {
	action: Pick<CargoAction, "start" | "end" | "displayAsWindow" | "simulatedTimestamp"> | undefined | null;
	format?: string;
	withoutYear?: boolean;
	hideIfSimulated?: boolean;
};

export const CargoActionDate = ({ action, withoutYear, format, hideIfSimulated }: CargoActionDateProps) => {
	if (!action || action.simulatedTimestamp && hideIfSimulated || action.start == null && action.end == null) {
		return undefined;
	}

	return (
		<span style={{ color: action.simulatedTimestamp ? "grey" : "inherit", flexShrink: 0 }}>
			{action.displayAsWindow ? (
				<FormattedDateWindow
					from={moment(action.start)}
					to={moment(action.end)}
					withoutYear={withoutYear}
					format={format}
				/>
			) : (
				<FormattedDate
					date={action.start}
					format={format ?? "ll"}
					withoutYear={withoutYear}
				/>
			)}
		</span>
	);
};
